// @flow

export default {
  name: 'UiFunds',
};
